import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/traffic-red.png'
import _imports_1 from '@/assets/images/traffic-green.png'
import _imports_2 from '@/assets/images/traffic-amber.png'


const _withScopeId = n => (_pushScopeId("data-v-d9801190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light booking-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-header booking-section-header" }, "Issue Report", -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "row",
  style: {"margin-left":"-12px","margin-right":"-12px"}
}
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = {
  key: 0,
  class: "multiselecttags"
}
const _hoisted_7 = {
  key: 1,
  style: {"display":"inline-flex"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { style: {"display":"inline-flex"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "multiselecttags"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "col-md-2 mt-auto mb-auto" }
const _hoisted_17 = {
  class: "btn btn-sm btn-outline-secondary",
  style: {"min-height":"33.2px"}
}
const _hoisted_18 = {
  key: 0,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_19 = {
  key: 1,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_20 = {
  key: 2,
  class: "trafficlight",
  src: _imports_2
}
const _hoisted_21 = { class: "col-md-2 mt-auto mb-auto" }
const _hoisted_22 = {
  class: "btn btn-sm btn-outline-secondary",
  style: {"min-height":"33.2px"}
}
const _hoisted_23 = {
  key: 0,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_24 = {
  key: 1,
  class: "trafficlight",
  src: _imports_2
}
const _hoisted_25 = {
  key: 2,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_26 = { class: "row mt-3" }
const _hoisted_27 = { class: "col-md-3 mt-auto mb-auto" }
const _hoisted_28 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Issue report to client"
}
const _hoisted_29 = {
  key: 0,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_30 = {
  key: 1,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "col-md-3 mt-auto mb-auto" }
const _hoisted_34 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Issue report to landlord"
}
const _hoisted_35 = {
  key: 0,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_36 = {
  key: 1,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "col-md-2 mt-auto mb-auto" }
const _hoisted_40 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Issue report to tenant"
}
const _hoisted_41 = {
  key: 0,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_42 = {
  key: 1,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "col-md-2 mt-auto mb-auto" }
const _hoisted_46 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Issue report to tenant"
}
const _hoisted_47 = {
  key: 0,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_48 = {
  key: 1,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { EmailLogs, Booking, Report } from "@/models";
import { useToast } from "vue-toastification";
import EmailLogsModal from "@/components/modals/EmailLogsModal.vue";
import MiscNotesDialog from '@/components/modals/MiscNotesDialog.vue';
import IssueReportEmailModal from "@/components/modals/IssueReportEmailModal.vue";
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'IssuingReport',
  emits: [''],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const toast = useToast();
const route = useRoute();

const reportref = ref('');
const subreportref = ref('');
const errorreportref = ref(false);
const errorsubreportref = ref(false);
const qcRulesDialog = ref(null);
const clientEmailModal = ref(null);
const issuereporttoclientEmailLogsModal = ref(null);
const landlordEmailModal = ref(null);
const issuereporttolandlordEmailLogsModal = ref(null);
const tenantEmailModal = ref(null);
const invoiceEmailModal = ref(null);
const issuereporttotenantEmailLogsModal = ref(null);
const issueinvoiceEmailLogsModal = ref(null);

const getReportCheckPostCode = async (payload: { ref: string; postcode: string, type: string }): Promise<any> => {
  return await store.dispatch('reports/getReportCheckPostCode', payload);
};
const setBookingDeep = (payload: { path: string; data: any }) => store.dispatch('diary/setBookingDeep', payload);

// Getters
const store = useStore();
const booking = computed((): Booking => store.getters['diary/booking']);
const systemproperties = computed(() => store.getters['dictionary/systemproperties']);
const emaillogs = computed((): EmailLogs => store.getters['diary/emaillogs']);

const reporttype = computed(() => booking.value.jobtype);
const clienttarget = computed(() =>
  booking.value.managedtype === 'Managed' ? "Managed Client" : "Non-Managed Client"
);
const fromaddress = computed(() => {
  let prop = systemproperties.value?.find(sp => sp.propertykey === 'booking.email.fromaddress');
  return prop?.value;
});

const tenanttoaddresses = computed(() => {
  let toaddresses = [];
  if (booking.value && booking.value.tenants && booking.value.tenants.length) {
    toaddresses = booking.value.tenants
      .filter(t => t.ttemail)
      .map(t => t.ttemail);
  }
  return [...toaddresses];
});


watch(() => booking.value.id, async () => {
  if (booking.value.id) {
    reportref.value = '';
    subreportref.value = '';
    errorreportref.value = false;
  }
});

const onSubmit = async () => {
  if (reportref.value && !isNewBooking()) {
    errorreportref.value = false;
    let response = await getReportCheckPostCode({ ref: reportref.value, postcode: booking.value.address.postcode, type: booking.value.jobtype });
    if (response) {
      errorreportref.value = false;
      booking.value.report.id = response;
      booking.value.report.firstexportedby = booking.value?.inspector?.email;
      booking.value.report.ref = reportref.value;
      setBookingDeep({ path: 'report', data: booking.value.report });
    } else {
      errorreportref.value = true;
      toast.error('Selected report does does not match with this booking');
    }
  }
};

const onSubReport = async () => {
  if (subreportref.value && !isNewBooking()) {
    errorsubreportref.value = false;
    let response = await getReportCheckPostCode({ ref: subreportref.value, postcode: booking.value.address.postcode, type: booking.value.jobtype });
    if (response) {
      errorsubreportref.value = false;
      let report = new Report();
      report.id = response;
      report.ref = subreportref.value;
      booking.value.subreports.push(report);
      setBookingDeep({ path: 'subreports', data: booking.value.subreports });
    } else {
      errorsubreportref.value = true;
      toast.error('Selected sub report does does not match with this booking');
    }
  }
}

const clearRef = () => {
  errorreportref.value = false;
  booking.value.report.id = '';
  booking.value.report.ref = '';
  reportref.value = '';
  setBookingDeep({ path: 'report', data: booking.value.report });
};


const clearsubRef = (index: number) => {
  errorsubreportref.value = false;
  booking.value.subreports.splice(index, 1);
  setBookingDeep({ path: 'subreports', data: booking.value.subreports });
};
const showQCRulesDialog = () => {
  const modal = qcRulesDialog.value as any;
  modal.show();
}

const showEmailClientDialog = () => {
  const modal = clientEmailModal.value as any;
  modal.init();
  modal.show();
}
const showClientEmailLogsDialog = () => {
  const modal = issuereporttoclientEmailLogsModal.value as any;
  modal.init();
  modal.show();
}

const showEmailTenantDialog = () => {
  const modal = tenantEmailModal.value as any;
  modal.init();
  modal.show();
}
const showLandlordEmailLogsDialog = () => {
  const modal = issuereporttolandlordEmailLogsModal.value as any;
  modal.init();
  modal.show();
}

const showEmailLandlordDialog = () => {
  const modal = landlordEmailModal.value as any;
  modal.init();
  modal.show();
}
const showTenantEmailLogsDialog = () => {
  const modal = issuereporttotenantEmailLogsModal.value as any;
  modal.init();
  modal.show();
}
const showEmailInvoiceDialog = () => {
  const modal = invoiceEmailModal.value as any;
  modal.init();
  modal.show();
}
const showInvoiceEmailLogsDialog = () => {
  const modal = issueinvoiceEmailLogsModal.value as any;
  modal.init();
  modal.show();
}
const isNewBooking = () => {
  return route.params.id == "new";
}

const feedbackstatus = computed(() => {
  var val = '';
  if (booking.value.report.feedbackstatus === 'Opened') {
    val = 'amber';
  }
  else if (booking.value.report.feedbackstatus === 'Received') {
    val = 'red';
  }
  else if (!booking.value.report.feedbackstatus || booking.value.report.feedbackstatus === 'Acknowledged') {
    val = 'green';
  }
  return val;
});

const emailtoclientstatus = computed(() => {
  var val = 'green';
  if (booking.value.clientqcrule && booking.value.clientqcrule.email) {
    if (emaillogs.value.issuereportemailsendtoclientdate) {
      val = 'green';
    } else {
      val = 'red';
    }
  }
  return val;
});

const emailtolandlordstatus = computed(() => {
  var val = 'green';
  if (booking.value.landlordqcrule && booking.value.landlordqcrule.email) {
    if (emaillogs.value.issuereportemailsendtolandlorddate) {
      val = 'green';
    } else {
      val = 'red';
    }
  }
  return val;
});

const emailtotenantstatus = computed(() => {
  var val = 'green';
  if (tenanttoaddresses.value.length) {
    if (emaillogs.value.issuereportemailsendtotenantdate) {
      val = 'green';
    } else {
      val = 'red';
    }
  }
  return val;
});

const emailinvalidstatus = computed(() => {
  var val = 'green';
  if (booking.value.invoiceqcrule && booking.value.invoiceqcrule.email) {
    if (emaillogs.value.invoicesentdate) {
      val = 'green';
    } else {
      val = 'red';
    }
  }
  return val;
});

const issuestatus = computed(() => {
  const statusarray = [feedbackstatus.value, emailtoclientstatus.value, emailtolandlordstatus.value, emailtotenantstatus.value, emailinvalidstatus.value];
  const redindex = statusarray.findIndex((v) => v === 'red');
  const amberindex = statusarray.findIndex((v) => v === 'amber');
  if (redindex >= 0) return 'red';
  else if (amberindex >= 0) return 'amber';
  else return 'green';
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (booking.value.report && booking.value.report.ref)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["multiselecttag", {'withoutuserprofile': booking.value.report.firstexportedby?.toLocaleLowerCase() != booking.value.inspector?.email.toLocaleLowerCase()}])
                  }, [
                    _createTextVNode(_toDisplayString(booking.value.report.ref) + " ", 1),
                    _createElementVNode("i", {
                      tabindex: "1",
                      class: "multiselect__tag-icon",
                      onClick: clearRef
                    })
                  ], 2)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    class: _normalizeClass(["form-control", {
              outlineerror:
                errorreportref.value,
            }]),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reportref).value = $event)),
                    placeholder: "Report ref"
                  }, null, 2), [
                    [
                      _vModelText,
                      reportref.value,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-outline-primary",
                    onClick: onSubmit
                  }, _hoisted_9)
                ]))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "0",
                class: _normalizeClass(["form-control", {
                outlineerror:
                  errorsubreportref.value,
              }]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subreportref).value = $event)),
                placeholder: "Sub Report ref"
              }, null, 2), [
                [
                  _vModelText,
                  subreportref.value,
                  void 0,
                  { lazy: true }
                ]
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-outline-primary",
                onClick: onSubReport
              }, _hoisted_13)
            ]),
            (booking.value.subreports)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.subreports, (sub, $index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: $index,
                      class: "multiselecttag"
                    }, [
                      _createTextVNode(_toDisplayString(sub.ref) + " ", 1),
                      _createElementVNode("i", {
                        tabindex: "1",
                        class: "multiselect__tag-icon",
                        onClick: ($event: any) => (clearsubRef($index))
                      }, null, 8, _hoisted_15)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", { class: "col-md-2 mt-auto mb-auto" }, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-secondary",
              onClick: showQCRulesDialog
            }, "QC Rules")
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", _hoisted_17, [
              (feedbackstatus.value === 'red')
                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                : (feedbackstatus.value === 'green')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                  : (feedbackstatus.value === 'amber')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                    : _createCommentVNode("", true),
              _createTextVNode(" Feedback ")
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", _hoisted_22, [
              (issuestatus.value === 'red')
                ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                : (issuestatus.value === 'amber')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                  : (_openBlock(), _createElementBlock("img", _hoisted_25)),
              _createTextVNode(" Status ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (booking.value.clientqcrule && booking.value.clientqcrule.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: showEmailClientDialog
                  }, [
                    (emaillogs.value.issuereportemailsendtoclientdate)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                      : (_openBlock(), _createElementBlock("img", _hoisted_30)),
                    _createTextVNode(" Email to Client ")
                  ]),
                  (emaillogs.value.issuereportclientlogs.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: showClientEmailLogsDialog
                      }, _hoisted_32))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            (booking.value.landlordqcrule && booking.value.landlordqcrule.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: showEmailLandlordDialog
                  }, [
                    (emaillogs.value.issuereportemailsendtolandlorddate)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                      : (_openBlock(), _createElementBlock("img", _hoisted_36)),
                    _createTextVNode(" Email to Landlord ")
                  ]),
                  (emaillogs.value.issuereportlandlordlogs.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: showLandlordEmailLogsDialog
                      }, _hoisted_38))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            (tenanttoaddresses.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: showEmailTenantDialog
                  }, [
                    (emaillogs.value.issuereportemailsendtotenantdate)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                      : (_openBlock(), _createElementBlock("img", _hoisted_42)),
                    _createTextVNode(" Email to Tenant ")
                  ]),
                  (emaillogs.value.issuereporttenantlogs.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: showTenantEmailLogsDialog
                      }, _hoisted_44))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_45, [
            (booking.value.invoiceqcrule && booking.value.invoiceqcrule.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: showEmailInvoiceDialog
                  }, [
                    (emaillogs.value.invoicesentdate)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                      : (_openBlock(), _createElementBlock("img", _hoisted_48)),
                    _createTextVNode(" Email Invoice ")
                  ]),
                  (emaillogs.value.issuereportinvoicelogs.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: showInvoiceEmailLogsDialog
                      }, _hoisted_50))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(MiscNotesDialog, {
        ref_key: "qcRulesDialog",
        ref: qcRulesDialog,
        modalid: "qcrules",
        title: `QC Rules`,
        notes: booking.value.customer.qcrules.misc
      }, null, 8, ["notes"]),
      _createVNode(IssueReportEmailModal, {
        id: "issuetoclient-email-modal",
        name: "issuetoclient-email-modal",
        ref_key: "clientEmailModal",
        ref: clientEmailModal,
        title: "Issue report to client",
        reporttype: reporttype.value,
        target: clienttarget.value,
        chronorder: "Issue Report",
        customer: booking.value.customer.id,
        fromaddress: fromaddress.value,
        qcrules: booking.value.clientqcrule
      }, null, 8, ["reporttype", "target", "customer", "fromaddress", "qcrules"]),
      _createVNode(IssueReportEmailModal, {
        id: "issuetolandlord-email-modal",
        name: "issuetolandlord-email-modal",
        ref_key: "landlordEmailModal",
        ref: landlordEmailModal,
        title: "Issue report to landlord",
        reporttype: reporttype.value,
        target: "Landlord",
        chronorder: "Issue Report",
        customer: booking.value.customer.id,
        fromaddress: fromaddress.value,
        qcrules: booking.value.landlordqcrule
      }, null, 8, ["reporttype", "customer", "fromaddress", "qcrules"]),
      _createVNode(IssueReportEmailModal, {
        id: "issuetotenant-email-modal",
        name: "issuetotenant-email-modal",
        ref_key: "tenantEmailModal",
        ref: tenantEmailModal,
        title: "Issue report to tenant",
        reporttype: reporttype.value,
        target: "Tenant",
        chronorder: "Issue Report",
        customer: booking.value.customer.id,
        fromaddress: fromaddress.value,
        qcrules: booking.value.tenantqcrule
      }, null, 8, ["reporttype", "customer", "fromaddress", "qcrules"]),
      _createVNode(IssueReportEmailModal, {
        id: "issuetoinvoice-email-modal",
        name: "issuetoinvoice-email-modal",
        ref_key: "invoiceEmailModal",
        ref: invoiceEmailModal,
        title: "Issue report to invoice",
        reporttype: reporttype.value,
        target: "Invoice",
        chronorder: "Issue Report",
        customer: booking.value.customer.id,
        fromaddress: fromaddress.value,
        qcrules: booking.value.invoiceqcrule
      }, null, 8, ["reporttype", "customer", "fromaddress", "qcrules"])
    ]),
    _createVNode(EmailLogsModal, {
      name: "issuereporttoclient-emaillogs-modal",
      ref_key: "issuereporttoclientEmailLogsModal",
      ref: issuereporttoclientEmailLogsModal,
      target: "Client",
      title: "Issue report to client - email logs",
      chronorder: "Issue Report"
    }, null, 512),
    _createVNode(EmailLogsModal, {
      name: "issuereporttolandlord-emaillogs-modal",
      ref_key: "issuereporttolandlordEmailLogsModal",
      ref: issuereporttolandlordEmailLogsModal,
      target: "Landlord",
      title: "Issue report to landlord - email logs",
      chronorder: "Issue Report"
    }, null, 512),
    _createVNode(EmailLogsModal, {
      name: "issuereporttotenant-emaillogs-modal",
      ref_key: "issuereporttotenantEmailLogsModal",
      ref: issuereporttotenantEmailLogsModal,
      target: "Tenant",
      title: "Issue report to tenant - email logs",
      chronorder: "Issue Report"
    }, null, 512),
    _createVNode(EmailLogsModal, {
      name: "issueinvoice-emaillogs-modal",
      ref_key: "issueinvoiceEmailLogsModal",
      ref: issueinvoiceEmailLogsModal,
      target: "Invoice",
      title: "Issue invoice - email logs",
      chronorder: "Issue Report"
    }, null, 512)
  ], 64))
}
}

})